import { createContext } from 'react';

import { Context } from '../../../types';
import { CreditPaymentOption } from '../types';
import api from '../api';
import { getContextDefaultValues } from '../../providersDataManager';

export default createContext<Context<CreditPaymentOption>>(getContextDefaultValues(api));
